// import React, { useState } from "react";
// import { handleUpdate } from "./updateCertificateHandler";
// import TutorialGambar from "../../imageTutorial";
// import { placeholderImage, isValidUrl } from "../../invalidImage";
// import { Toggle } from "rsuite";

// const ModalUpdateCertificate = ({ certificate, onClose }) => {
//   const [imageUrl, setImageUrl] = useState(certificate.img);
//   const [name, setName] = useState(certificate.name);
//   const [organizer, setOrganizer] = useState(certificate.organizer);
//   const [link, setLink] = useState(certificate.link);
//   const [status, setStatus] = useState(certificate.status);
//   const [type, setType] = useState(certificate.type); // Tambahkan kolom type

//   return (
//     <div>
//       <div
//         id="crud-modal"
//         aria-hidden="true"
//         className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full overflow-y-auto overflow-x-hidden bg-black bg-opacity-50"
//       >
//         <div className="relative p-4 w-full max-w-4xl max-h-full">
//           <div className="relative bg-white rounded-lg shadow dark:bg-gray-700 text-white">
//             <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Update Certificate
//               </h3>
//               <button
//                 type="button"
//                 className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
//                 onClick={onClose}
//               >
//                 <svg
//                   className="w-3 h-3"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 14 14"
//                 >
//                   <path
//                     stroke="currentColor"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
//                   />
//                 </svg>
//                 <span className="sr-only">Close modal</span>
//               </button>
//             </div>
//             <form
//               className="p-4 md:p-5"
//               onSubmit={(e) =>
//                 handleUpdate(e, certificate.id, name, imageUrl, organizer, link, status, type, onClose)
//               }
//             >
//               <div className="grid gap-4 mb-4 grid-cols-1 md:grid-cols-2">
//                 <div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="name"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Name
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       id="name"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Type certificate name"
//                       value={name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="organizer"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Organizer
//                     </label>
//                     <input
//                       type="text"
//                       name="organizer"
//                       id="organizer"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Type organizer name"
//                       value={organizer}
//                       onChange={(e) => setOrganizer(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="link"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Link
//                     </label>
//                     <input
//                       type="text"
//                       name="link"
//                       id="link"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Paste certificate link"
//                       value={link}
//                       onChange={(e) => setLink(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="imageUrl"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Image URL
//                     </label>
//                     <input
//                       type="text"
//                       name="imageUrl"
//                       id="imageUrl"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Paste image URL here"
//                       value={imageUrl}
//                       onChange={(e) => setImageUrl(e.target.value)}
//                     />
//                   </div>
//                   {imageUrl && (
//                     <div className="relative mt-3 h-36">
//                       <img
//                         src={isValidUrl(imageUrl) ? imageUrl : placeholderImage}
//                         alt="Selected"
//                         className="rounded-lg object-contain h-full w-full"
//                       />
//                     </div>
//                   )}
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="type"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Type
//                     </label>
//                     <input
//                       type="text"
//                       name="type"
//                       id="type"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Enter certificate type"
//                       value={type}
//                       onChange={(e) => setType(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2 flex items-center mt-4">
//                     <label
//                       htmlFor="status"
//                       className="text-sm font-medium text-gray-900 dark:text-white mr-2"
//                     >
//                       Status:
//                     </label>
//                     <Toggle
//                       checked={status === 1}
//                       onChange={(value) => setStatus(value ? 1 : 0)}
//                       size="sm"
//                     />
//                   </div>
//                   <button
//                     type="submit"
//                     className="mt-4 text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
//                   >
//                     <svg
//                       className="me-1 -ms-1 w-5 h-5"
//                       fill="currentColor"
//                       viewBox="0 0 20 20"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M10 5a1 1 011 1v3h3a1 1 110 2h-3v3a1 1 11-2 0v-3H6a1 1 110-2h3V6a1 1 111-1z"
//                         clipRule="evenodd"
//                       ></path>
//                     </svg>
//                     Update certificate
//                   </button>
//                 </div>
//                 <TutorialGambar />
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ModalUpdateCertificate;


import React, { useState, useEffect } from "react";
import { handleUpdate } from "./updateCertificateHandler";
import ImageUploader from "../ImageUploader";
import { Toggle } from "rsuite";
import { fetchCertificateCategories } from "../../../api/certificateAPI";

const ModalUpdateCertificate = ({ certificate, onClose }) => {
  const [imageUrl, setImageUrl] = useState(certificate.img);
  const [name, setName] = useState(certificate.name);
  const [organizer, setOrganizer] = useState(certificate.organizer);
  const [link, setLink] = useState(certificate.link);
  const [status, setStatus] = useState(certificate.status);
  const [type, setType] = useState(certificate.type);
  const [category, setCategory] = useState(certificate.category ?? "");
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");

  useEffect(() => {
    fetchCertificateCategories().then(setCategories).catch(() => {});
  }, []);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      {/* Container utama modal dengan pembatasan tinggi agar tidak terpotong */}
      <div className="relative w-full max-w-5xl bg-white dark:bg-gray-800 rounded-[2rem] shadow-2xl flex flex-col max-h-[95vh] overflow-hidden border border-gray-100 dark:border-gray-700 animate-in fade-in zoom-in duration-300">
        
        {/* Header: Dibuat tetap di atas (Sticky) */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-8 py-5 text-white flex justify-between items-center shrink-0 shadow-md">
          <div className="flex items-center gap-3">
            <svg className="w-6 h-6 opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            <h3 className="text-xl font-black tracking-tight uppercase italic">
              Update Certificate
            </h3>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-full transition-all active:scale-90"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body Modal: Area yang bisa di-scroll jika konten panjang */}
        <div className="overflow-y-auto p-8 lg:p-10 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
          <form 
            onSubmit={(e) => handleUpdate(e, certificate.id, name, imageUrl, organizer, link, status, type, onClose, category)}
          >
            <div className="grid grid-cols-1 gap-6">

              {/* Input Form */}
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700 dark:text-gray-300">Certificate Name</label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                      placeholder="Type certificate name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-bold text-gray-700 dark:text-gray-300">Organizer</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                      placeholder="Type organizer"
                      value={organizer}
                      onChange={(e) => setOrganizer(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-bold text-gray-700 dark:text-gray-300">Type</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                      placeholder="e.g. Course / Award"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700 dark:text-gray-300">Category</label>
                    <select
                      value={newCategory ? "" : category}
                      onChange={(e) => { setCategory(e.target.value); setNewCategory(""); }}
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    >
                      <option value="">-- Pilih / Buat Baru --</option>
                      {categories.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                    <input
                      type="text"
                      className="mt-2 w-full px-4 py-2.5 bg-gray-50 dark:bg-gray-700 border border-dashed border-gray-300 dark:border-gray-500 text-gray-800 dark:text-white rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all text-sm placeholder:text-gray-400"
                      placeholder="Atau ketik kategori baru (misal: NOC, Cyber Security)..."
                      value={newCategory}
                      onChange={(e) => { setNewCategory(e.target.value); setCategory(e.target.value); }}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700 dark:text-gray-300">Link Kredensial (URL)</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-700 text-white border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-mono text-sm"
                      placeholder="https://verify.link/..."
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <ImageUploader
                      value={imageUrl}
                      onChange={setImageUrl}
                      label="Certificate Image"
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between p-5 bg-indigo-50 dark:bg-indigo-900/20 rounded-2xl border border-indigo-100 dark:border-indigo-800 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg ${status === 1 ? 'bg-green-500' : 'bg-gray-400'} text-white`}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                    </div>
                    <div>
                      <p className="text-sm font-black uppercase text-indigo-900 dark:text-indigo-200 tracking-wider">Public Visibility</p>
                      <p className="text-xs text-indigo-700/60 dark:text-indigo-300/40 font-medium">{status === 1 ? 'Certificate is active in portfolio' : 'Certificate is hidden'}</p>
                    </div>
                  </div>
                  <Toggle
                    checked={status === 1}
                    onChange={(value) => setStatus(value ? 1 : 0)}
                    size="md"
                  />
                </div>
              </div>

            </div>

            {/* Footer Buttons: Tetap di bawah dalam form */}
            <div className="mt-10 pt-8 border-t border-gray-100 dark:border-gray-700 flex flex-col md:flex-row gap-4 justify-end">
              <button
                type="button"
                onClick={onClose}
                className="px-8 py-3 text-sm font-black text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors uppercase tracking-widest"
              >
                Discard
              </button>
              <button
                type="submit"
                className="px-12 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-black rounded-xl shadow-lg shadow-indigo-200 dark:shadow-none transition-all active:scale-95 flex items-center justify-center uppercase tracking-wider text-sm"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalUpdateCertificate;